var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { ETeam } from '../../../types';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { selectMatchState } from '../../../store/match';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
import { calculateRolesCount, getTeamPowers } from '../../../api';
import { TableUser } from '../../atoms/Tables/TableUser/TableUser';
import { TableStatistical } from '../../atoms/Tables/TableStatistical/TableStatistical';
import { TableUserItem } from '../../atoms/Tables/TableUserItem/TableUserItem';
import { Counter } from '../../atoms/Counter/Counter';
import { TotalUsers } from '../../atoms/TotalUsers/TotalUsers';
import styles from './RoleCountSetup.module.scss';
import { TableUserPayment } from '../../atoms/Tables/TableUserPayment/TableUserPayment';
export function RolesCount({ setChosenRoles }) {
    var _a;
    const { errorHandler } = useErrorHandler();
    const dispatch = useAppDispatch();
    const [selectedRole, setSelectedRole] = useState();
    const matchState = useAppSelector(selectMatchState);
    const allPlayers = (matchState === null || matchState === void 0 ? void 0 : matchState.players) || [];
    const roles = (matchState === null || matchState === void 0 ? void 0 : matchState.roles) || [];
    const [counts, setCounts] = useState([]);
    const [boughtCount, setBoughtCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [balanceRequestSent, setBalanceRequestSent] = useState(false);
    const [civiliansPower, setCivPower] = useState(0);
    const [mafiaPower, setMafiaPower] = useState(0);
    useEffect(() => {
        // Ваш код, который будет выполняться при каждом изменении counts
        console.log('counts изменился', counts);
        // Дополнительная логика, если нужно
    }, [counts]);
    const handlePlus = useCallback((item) => {
        const newCounts = counts.map((role) => {
            if (role.role === item.role) {
                item.count++;
                return item;
            }
            return role;
        });
        setCounts(newCounts);
    }, [counts]);
    const onBalanceButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        if (!(matchState === null || matchState === void 0 ? void 0 : matchState.id))
            return;
        try {
            setBalanceRequestSent(true);
            const result = yield calculateRolesCount(matchState.id);
            console.log('Balance Result:', result);
            const updatedCounts = counts.map((role) => {
                const balanceRoleCount = result.roles[role.role];
                if (balanceRoleCount !== undefined) {
                    return Object.assign(Object.assign({}, role), { count: Number(balanceRoleCount) });
                }
                return role;
            });
            setCounts(updatedCounts);
        }
        catch (err) {
            errorHandler(err);
            setBalanceRequestSent(false);
        }
        finally {
            setBalanceRequestSent(false);
        }
    });
    const handleMinus = useCallback((item) => {
        const newCounts = counts.map((role) => {
            if (role.role === item.role) {
                item.count--;
                return item;
            }
            return role;
        });
        setCounts(newCounts);
    }, [counts]);
    useEffect(() => {
        const list = [];
        roles.map((role) => {
            const object = {
                team: role.team,
                role: role.machineName,
                name: `${role.name} (${role.power})`,
                count: role.setCount.min,
                maxCount: role.setCount.max,
                minCount: role.setCount.min,
                machineName: role.machineName,
                boughtCount: 0,
            };
            if (matchState) {
                (matchState.state.purchases || []).map((item) => {
                    if (object.role === item.roleAlias) {
                        object.boughtCount++;
                        setBoughtCount(boughtCount + 1);
                    }
                });
            }
            if (role.setCount.max !== 0) {
                list.push(object);
            }
        });
        setCounts(list);
    }, [roles]);
    useEffect(() => { }, [allPlayers, counts]);
    // const onPlayerSelect = async (role: ERoleTypes) => {
    //   if (player) {
    //     // console.log('PlayerRole onRoleChange', e.target.value)
    //   }
    // }
    useEffect(() => {
        const rolesWithCount = counts.filter((item) => item.count > 0);
        const chosenRoles = Object.fromEntries(rolesWithCount.map((item) => [item.role, item.count]));
        const chosenCount = Object.values(chosenRoles).reduce((acc, number) => acc + number, 0);
        console.log('chosenCount', chosenCount);
        setTotalCount(chosenCount);
        setChosenRoles(chosenRoles);
        // const chosenRoles = Object.fromEntries()
    }, [counts]);
    useEffect(() => {
        const fetchTeamPowers = () => __awaiter(this, void 0, void 0, function* () {
            const rolesWithCount = counts.filter((item) => item.count > 0);
            const chosenRoles = Object.fromEntries(rolesWithCount.map((item) => [item.role, item.count]));
            const chosenCount = Object.values(chosenRoles).reduce((acc, number) => acc + number, 0);
            console.log('chosenCount', chosenCount);
            setTotalCount(chosenCount);
            setChosenRoles(chosenRoles);
            try {
                const powers = yield getTeamPowers(chosenRoles);
                setCivPower(powers.civilians);
                setMafiaPower(powers.mafia);
            }
            catch (error) {
                console.error('Ошибка при получении сил команд:', error);
            }
        });
        fetchTeamPowers();
    }, [counts]);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: styles.content }, { children: [_jsx(TableUser, { headerSlot: _jsx(TableStatistical, { title: "\u041C\u0438\u0440\u043D\u044B\u0435" }), data: counts.filter((item) => item.team == ETeam.CIVILIANS && item.machineName !== 'PSYCHO' && item.machineName !== 'WEREWOLF'), columns: ['Роль (сила)', 'Кол-во'], renderRow: (item, index, array) => {
                        const isLast = index === array.length - 1;
                        const { name, count, maxCount, minCount } = item;
                        return (_jsx(TableUserItem, { name: name, max: maxCount, min: minCount, isLast: isLast, slot: _jsx(Counter, { value: count, allPlayers: allPlayers, item: item, totalCount: totalCount, handleMinus: handleMinus, handlePlus: handlePlus }) }, name));
                    } }), _jsxs("div", Object.assign({ className: styles.center }, { children: [_jsx(TableUser, { headerSlot: _jsx(TableStatistical, { title: "\u041C\u0430\u0444\u0438\u044F" }), data: counts.filter((item) => item.team == ETeam.MAFIA), columns: ['Роль (сила)', 'Кол-во'], renderRow: (item, index, array) => {
                                const isLast = index === array.length - 1;
                                const { name, count, maxCount, minCount } = item;
                                return (_jsx(TableUserItem, { name: name, max: maxCount, min: minCount, isLast: isLast, slot: _jsx(Counter, { value: count, allPlayers: allPlayers, item: item, totalCount: totalCount, handleMinus: handleMinus, handlePlus: handlePlus }) }, name));
                            } }), _jsx(TableUser, { data: (_a = matchState === null || matchState === void 0 ? void 0 : matchState.state.purchases) !== null && _a !== void 0 ? _a : [], headerSlot: _jsx(TableStatistical, { title: "\u041F\u043E\u043A\u0443\u043F\u043A\u0438 \u0440\u043E\u043B\u0435\u0439" }), columns: ['Игрок', 'Роль'], renderRow: (item, index, array) => {
                                const isLast = index === array.length - 1;
                                return (_jsx(TableUserPayment, { name: item.player.realName, gameName: item.player.gameName, role: item.roleName, isLast: isLast }, item.player.id));
                            } })] })), _jsxs("div", Object.assign({ className: styles.side }, { children: [_jsx(TotalUsers, { total: allPlayers.length, mafia: mafiaPower, civilians: civiliansPower, rolesGranted: totalCount, rolesFree: allPlayers.length - totalCount }), _jsx(TableUser, { headerSlot: _jsx(TableStatistical, { title: "\u041D\u0435\u0439\u0442\u0440\u0430\u043B\u044B" }), data: counts.filter((item) => item.machineName == 'PSYCHO' || item.machineName == 'WEREWOLF'), columns: ['Роль (сила)', 'Кол-во'], renderRow: (item, index, array) => {
                                const isLast = index === array.length - 1;
                                const { name, count, maxCount, minCount } = item;
                                return (_jsx(TableUserItem, { name: name, max: maxCount, min: minCount, isLast: isLast, slot: _jsx(Counter, { value: count, allPlayers: allPlayers, item: item, totalCount: totalCount, handleMinus: handleMinus, handlePlus: handlePlus }) }, name));
                            } })] }))] })) }));
}
